var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1745 6.27908H13.9884C12.3873 6.27908 11.1628 7.53877 11.1628 9.18606V16.938C11.1628 18.4884 12.3873 19.845 13.9884 19.845H23.407L27.1745 23.7209V19.845C28.7756 19.845 30.0001 18.4884 30.0001 16.938V9.18606C30.0001 7.53877 28.7756 6.27908 27.1745 6.27908Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0116 0H2.82558C1.22442 0 0 1.2093 0 2.7907V10.2326C0 11.7209 1.22442 13.0233 2.82558 13.0233V16.7442L6.59302 13.0233H9.41861V9.30233C9.41861 6.69767 11.4907 4.65116 14.1279 4.65116H18.8372V2.7907C18.8372 1.2093 17.6128 0 16.0116 0Z",
    fill: "#38D200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPopup);
export default __webpack_public_path__ + "static/media/chat-popup.c8c3c8b05ec36c9771376d74114b311b.svg";
export { ForwardRef as ReactComponent };